(function () {
  function playVideo(video) {
    if (!video) return;
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    var playPromise = video.play();
    if (playPromise && playPromise.catch) playPromise.catch(function () {});
  }

  function setActiveMedia(videos, index) {
    videos.forEach(function (video, i) {
      var active = i === index;
      video.setAttribute('data-slide-active', active ? 'true' : 'false');
      if (active) {
        video.removeAttribute('aria-hidden');
        playVideo(video);
      } else {
        video.setAttribute('aria-hidden', 'true');
        if (!video.paused) video.pause();
      }
    });
  }

  function initAnatomy(root) {
    var videos = root.querySelectorAll('[data-anatomy-video]');
    var layers = root.querySelectorAll('[data-anatomy-layer]');
    if (!layers.length) return;

    var currentIndex = 0;
    layers.forEach(function (layer, i) {
      if (layer.classList.contains('is-active')) currentIndex = i;
    });
    setActiveMedia(videos, currentIndex);

    layers.forEach(function (layer) {
      layer.addEventListener('click', function () {
        var index = Number(layer.getAttribute('data-anatomy-layer'));
        if (Number.isNaN(index) || index === currentIndex) return;
        currentIndex = index;

        layers.forEach(function (l) {
          var active = Number(l.getAttribute('data-anatomy-layer')) === index;
          l.classList.toggle('is-active', active);
          var toggle = l.querySelector('[data-layer-toggle]');
          if (toggle) toggle.textContent = active ? '−' : '+';
        });

        setActiveMedia(videos, index);
      });
    });
  }

  function initFaq(root) {
    var tabs = root.querySelectorAll('[data-faq-tab]');
    var panels = root.querySelectorAll('[data-faq-panel]');

    function setFaqOpen(item, open) {
      item.classList.toggle('is-open', open);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-faq-tab');
        tabs.forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-faq-tab') === target);
        });
        panels.forEach(function (panel) {
          var active = panel.getAttribute('data-faq-panel') === target;
          panel.classList.toggle('is-active', active);
          if (!active) {
            panel.querySelectorAll('.mattress-landing-faq__item.is-open').forEach(function (item) {
              setFaqOpen(item, false);
            });
          }
        });
      });
    });

    root.querySelectorAll('[data-faq-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('.mattress-landing-faq__item');
        var panel = trigger.closest('[data-faq-panel]');
        if (!item || !panel) return;
        var wasOpen = item.classList.contains('is-open');
        panel.querySelectorAll('.mattress-landing-faq__item.is-open').forEach(function (openItem) {
          setFaqOpen(openItem, false);
        });
        if (!wasOpen) setFaqOpen(item, true);
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-mattress-anatomy]').forEach(initAnatomy);
    document.querySelectorAll('[data-mattress-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
